import { ComboField } from '@components/Fields/ComboField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { StringField } from '@components/Fields/StringField';
import { IForm } from '@hooks/useForm';
import { IClienteEvento } from '@model/ClienteEvento';
import { IComboClienteEventoTipo } from '@model/ClienteEventoTipo';
import React from 'react';

export type EventoRegistrarFormularioProps = {
    form: IForm<Partial<IClienteEvento>>
    clienteEventoTipoCombo: IComboClienteEventoTipo
    tipoInputRef: React.MutableRefObject<HTMLInputElement | undefined>
}

export function EventoRegistrarFormulario ({ clienteEventoTipoCombo, form, tipoInputRef}: EventoRegistrarFormularioProps) {
    const { fields } = form;

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={4}>
                <ComboField 
                    inputRef={tipoInputRef}
                    field={fields.clienteEventoTipoId}
                    label="Tipo"
                    required
                >
                    {
                        clienteEventoTipoCombo.createOptions()
                    }
                </ComboField>
            </GridItem>

            <GridItem xs={8}>
                <StringField 
                    field={fields.nota}
                    label="Nota"
                    required
                />
            </GridItem>
        </HorizontalGrid>
    )
}